export function setGlobalError(code, info) {
    return {
        type: 'SET_ERROR',
        payload: { code, info },
    };
}
